module.exports = __webpack_public_path__ + "img/arrow-right-white-2.0addd1b7.svg";